<template>
  <div class="degree-sign-up">
    <table-list
      :loading="loading"
      :search-form="searchForm(this)"
      :data="list"
      title="报名信息"
      :tabs-list="tabsList"
      :options="{ selection: true, operatesWidth: 200 }"
      :columns="columns(this)"
      :operates="operates(this)"
      :btns="btns(this)"
      :pager="pager"
      @search="onSearch"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></table-list>

    <el-dialog
      title="支付二维码"
      :visible.sync="qrVisible"
      :close-on-click-modal="false"
      width="460px"
    >
      <div class="qr-code-wrap">
        <p class="qr-code-tip">微信识别二维码，进入小程序支付学费</p>
        <img :src="currentQrUrl" alt="支付二维码" />
        <el-button type="primary" round @click="handleDownloadQrCode">下载二维码</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const tabsList = [
  {
    prop: 'status',
    activeValue: '',
    children: [
      { value: 1, label: '提交资料' },
      { value: 2, label: '审核资料' },
      { value: 3, label: '待缴费' },
      { value: 4, label: '已完成' },
    ],
  },
]

const btns = _this => [
  {
    label: '导出报名资料',
    type: 'primary',
    method: _this.handleExportDetail,
  },
  {
    label: '导出报名列表',
    type: 'primary',
    method: _this.handleExportList,
  },
]

const searchForm = _this => [
  {
    label: '姓名',
    prop: 'name',
    placeholder: '请输入姓名',
  },
  {
    label: '手机号',
    prop: 'phone',
    placeholder: '请输入手机号',
  },
  {
    label: '学历类型',
    prop: 'enrollDegreeType',
    type: 'select',
    filterable: true,
    clearable: true,
    placeholder: '请选择学历类型',
    children: _this.educationTypeList.map(item => ({
      value: item.tagName,
      label: item.tagName,
    })),
  },
  {
    label: '学校',
    prop: 'schoolName',
    type: 'select',
    filterable: true,
    clearable: true,
    placeholder: '请选择学校',
    children: _this.schoolList.map(item => ({
      value: item.tagName,
      label: item.tagName,
    })),
  },
  {
    label: '创建时间',
    prop: 'time',
    type: 'picker',
  },
]

const columns = () => [
  {
    prop: 'phone',
    label: '手机号',
    minWidth: '120px',
  },
  {
    prop: 'name',
    label: '报名人',
    minWidth: '100px',
  },
  {
    prop: 'enrollDegreeType',
    label: '报名学历类型',
    minWidth: '120px',
  },
  {
    prop: 'schoolName',
    label: '所选学校',
    minWidth: '180px',
  },
  {
    prop: 'majorName',
    label: '所选专业',
    minWidth: '140px',
  },
  {
    prop: 'remark',
    label: '备注',
    minWidth: '150px',
  },
  {
    prop: 'statusText',
    label: '当前状态',
    minWidth: '100px',
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: '150px',
  },
  {
    prop: 'payTime',
    label: '支付时间',
    minWidth: '150px',
  },
]

const operates = _this => [
  {
    label: '报名资料',
    method: _this.handleDetail,
  },
  {
    label: '支付二维码',
    method: _this.handleQrCode,
    isShow: row => row.status === 3,
  },
]

import TableList from '@/components/TableList'
import {
  degreeSignUpList,
  degreeSignUpDetailExport,
  degreeSignUpListExport,
  degreeProductQrCode,
  degreeProductEnrollCheck,
} from '@/api/degree'
import { deGreeSchoolFilter, deGreeTypeTagFilter } from '@/api/center'
import to from 'await-to'

export default {
  name: 'DegreeSignUp',
  components: {
    TableList,
  },
  data() {
    return {
      tabsList,
      btns,
      searchForm,
      columns,
      operates,
      loading: false,
      list: [],
      schoolList: [],
      educationTypeList: [],
      selectItems: [],
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
      queryParams: {},
      qrVisible: false,
      currentQrUrl: '',
    }
  },
  created() {
    this.getSchoolList()
    this.getEducationTypeList()
    this.getList()
  },
  methods: {
    async getList() {
      if (this.loading) return
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(degreeSignUpList({ current, size, ...this.queryParams }))
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.list = res.data.list || []
      this.pager.total = res.data.total || 0
    },
    async getSchoolList() {
      const [res, err] = await to(deGreeSchoolFilter({}))
      if (err) return this.$message.warning(err.msg)
      this.schoolList = res.data || []
    },
    async getEducationTypeList() {
      const [res, err] = await to(deGreeTypeTagFilter({}))
      if (err) return this.$message.warning(err.msg)
      this.educationTypeList = res.data || []
    },
    onSearch(queryParams) {
      this.pager.current = 1
      if (queryParams.time) {
        queryParams.beginTime = queryParams.time[0]
        queryParams.endTime = queryParams.time[1].split(' ')[0] + ' 23:59:59'
      } else {
        queryParams.beginTime = ''
        queryParams.endTime = ''
      }
      this.queryParams = queryParams
      this.getList()
    },
    handleSelectionChange(val) {
      this.selectItems = val
    },
    async handleExportDetail() {
      if (!this.selectItems.length) return this.$message.warning('请先选择要导出资料的报名人')
      const degreeEnrollIds = this.selectItems.map(item => item.degreeEnrollId)
      const [res, err] = await to(
        degreeSignUpDetailExport({
          degreeEnrollIds: degreeEnrollIds,
        }),
      )
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/zip',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '报名资料详情.zip'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    async handleExportList() {
      let idList = []
      this.selectItems.map(v => idList.push(v.degreeEnrollId))
      const { current, size } = this.pager
      const [res, err] = await to(
        degreeSignUpListExport({ current, size, ...this.queryParams, idList }),
      )
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '报名列表.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    downloadBlob(blobData, type, fileName) {
      const blob = new Blob([blobData], { type })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      if (fileName) a.download = fileName
      a.click()
      window.URL.revokeObjectURL(url)
    },
    handleDetail(row) {
      this.$router.push({
        path: '/degree/degreeSignUp/detail',
        query: { degreeEnrollId: row.degreeEnrollId },
      })
    },
    async handleCheckEnroll(degreeEnrollId) {
      const [res, err] = await to(degreeProductEnrollCheck({ degreeEnrollId }))
      if (err) return this.$message.warning(err.msg)
      return res.data
    },
    async handleQrCode(row) {
      this.currentQrUrl = ''
      const orderId = await this.handleCheckEnroll(row.degreeEnrollId)
      const [res, err] = await to(degreeProductQrCode({ page: 'pages/pay/index', param: orderId }))
      if (err) return this.$message.warning(err.msg)
      this.currentQrUrl = res.data
      this.qrVisible = true
    },
    handleDownloadQrCode() {
      if (!this.currentQrUrl) return
      window.open(this.currentQrUrl)
    },
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.getList()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
.degree-sign-up {
  .qr-code-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0 20px;
    .qr-code-tip {
      margin: 0 0 20px;
      font-size: 14px;
      color: #333;
    }
    img {
      width: 200px;
      height: 200px;
      margin-bottom: 20px;
    }
    .el-button {
      min-width: 120px;
    }
  }
}
</style>
